export default "__VITE_ASSET__CNaqYsVZ__"